import { EventCardList } from "./EventCardList";

export default EventCardList;
